module.exports = __webpack_public_path__ + "img/lemon03.8074c8f3.jpg";